import { useState, useEffect } from 'react';
import { Typography, Paper, Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import { AgGridReact } from 'ag-grid-react';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from "dayjs";
import img from "../../assets/img/spinner.svg";
// Iconos
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const Cargas_Omni = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { info } = location.state || {};

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [driver, setDriver] = useState([]);
    const [unit, setUnit] = useState(null);

    useEffect(() => 
    {
        window.scrollTo(0, 0);

        if (!info) 
        {
            navigate('/diesel/omni/ver');
            return;
        }

        let objeto;
        try 
        {
            objeto = typeof info === "string" ? JSON.parse(info) : info;
        } 
        catch (e) 
        {
            console.error("info inválido:", info, e);
            navigate('/diesel/omni/ver');
            return;
        }

        const sd = objeto?.startDate ? dayjs(objeto.startDate) : null;
        const ed = objeto?.endDate ? dayjs(objeto.endDate) : null;

        const fp = objeto?.fecha_previa ? dayjs(objeto.fecha_previa) : null;
        const fi = objeto?.fecha_inicio ? dayjs(objeto.fecha_inicio) : null;
        const fr = objeto?.fecha_reset ? dayjs(objeto.fecha_reset) : null;

        setStartDate(sd?.isValid() ? sd : null);
        setEndDate(ed?.isValid() ? ed : null);
        setUnit(objeto?.unit ?? null);
        setDriver(
            Array.isArray(objeto?.driver)
            ? objeto.driver
            : objeto?.driver
            ? [objeto.driver]
            : []
        );

        fetchData({
            operador: objeto?.operador ?? null,
            fecha_previa: fp?.isValid() ? fp.format("YYYY-MM-DD") : null,
            fecha_inicio: fi?.isValid() ? fi.format("YYYY-MM-DD") : null,
            fecha_reset: fr?.isValid() ? fr.format("YYYY-MM-DD") : null,
            ...(Number(objeto?.conWhere) === 1 ? { conWhere: 1 } : {}),
        });
    }, [info, navigate]);

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    //Función para formatear la fecha
    const formatDate = (date) => {
        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const columns = [
        {
            field: 'VehicleID', headerName: 'Vehicle ID',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
            filter: 'agTextColumnFilter'
        },
        { field: 'DriverID', headerName: 'Driver ID',
            headerClass: "align-right",
            cellStyle: { textAlign: "right" },
            filter: 'agTextColumnFilter'
        },
        { field: 'ParameterID', headerName: 'Parameter ID',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        {
            field: 'ExtractStartDate',
            headerName: 'Extract Start (Date)',
            cellStyle: { textAlign: "right" },
            valueFormatter: (p) => (p.value ? dayjs(p.value).format('MM/DD/YY') : ''),
        },
        { 
            field: 'ExtractStartTime', 
            headerName: 'Extract Start (Time)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        {
            field: 'ExtractEndDate',
            headerName: 'Extract End (Date)',
            cellStyle: { textAlign: "right" },
            filter: 'agDateColumnFilter',
            valueGetter: (p) => p.data?.ExtractEndDate ? dayjs(p.data.ExtractEndDate).startOf('day').toDate() : null,
            valueFormatter: (p) => (p.value ? dayjs(p.value).format('MM/DD/YY') : ''),
            filterParams: { browserDatePicker: true }
        },
        { field: 'ExtractEndTime', headerName: 'Extract End (Time)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'TripCount', headerName: 'Trip Count',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'TotalDistanceMiles', headerName: 'Total Distance (Miles)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'DrivingTimeMinutes', headerName: 'Driving Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'EngineTimeMinutes', headerName: 'Engine Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'IntertripIdleTimeMinutes', headerName: 'Intertrip Idle Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'OverRPMTimeMinutes', headerName: 'Over RPM Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'OverRPMCount', headerName: 'Over RPM Count',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'OverRPMMax', headerName: 'Over RPM Max (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'OverSpeedTimeMinutes', headerName: 'Over Speed Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'OverSpeedCount', headerName: 'Over Speed Count',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'OverSpeedMax', headerName: 'Over Speed Max (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'ShortWarmCount', headerName: 'Short Warm Count',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'ShortCoolCount', headerName: 'Short Cool Count',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'MovingTimeMinutes', headerName: 'Moving Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'ShortIdleTimeMinutes', headerName: 'Short Idle Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'TotalActiveTimeMinutes', headerName: 'Total Active Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'ExcessSpeedTimeMinutes', headerName: 'Excess Speed Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'CoastOutOfGearTimeMinutes', headerName: 'Coast Out Of Gear Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'IgnitionViolationCount', headerName: 'Ignition Violation Count',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'PTOTimeMinutes', headerName: 'PTO Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FaultStateChangeCount', headerName: 'Fault State Change Count',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FaultActiveTimeMinutes', headerName: 'Fault Active Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'TotalFuelGallons', headerName: 'Total Fuel (Gallons)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'IdleFuelGallons', headerName: 'Idle Fuel (Gallons)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'PTOFuelGallons', headerName: 'PTO Fuel (Gallons)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'ParkedIdleFuelGallons', headerName: 'Parked Idle Fuel (Gallons)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'J1708Used', headerName: 'J1708 Used',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'AutoExtract', headerName: 'Auto Extract',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'OverAutoExtract', headerName: 'Over Auto Extract',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'NewFirmware', headerName: 'New Firmware',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'UserOKData', headerName: 'User OK Data',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'EquivalentPreventativeMaintenanceMiles', headerName: 'Equivalent Preventative Maintenance (Miles)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FuelEfficiencyOmitFlag', headerName: 'Fuel Efficiency Omit Flag',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'IdleOmitFlag', headerName: 'Idle Omit Flag',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'ExcessSpeedOmitFlag', headerName: 'Excess Speed Omit Flag',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'SpeedOmitFlag', headerName: 'Speed Omit Flag',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'RPMOmitFlag', headerName: 'RPM Omit Flag',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FutureUse06', headerName: 'Future Use 06',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FutureUse07', headerName: 'Future Use 07',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FutureUse08', headerName: 'Future Use 08',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FutureUse09', headerName: 'Future Use 09',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FutureUse10', headerName: 'Future Use 10',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'CruiseGearOmitFlag', headerName: 'Cruise Gear Omit Flag',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'CruiseCtrlTimeMinutes', headerName: 'Cruise Ctrl Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'CruiseCtrlPercent', headerName: 'Cruise Ctrl %',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'TopGearTimeMinutes', headerName: 'Top Gear Time (Minutes)',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'TopGearPercent', headerName: 'Top Gear %',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'GearDataSource', headerName: 'Gear Data Source',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'FuelType', headerName: 'Fuel Type',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'uploadedBy', headerName: 'Usuario Subida',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
        },
        { field: 'uploadedAt', headerName: 'Fecha Subida',
            headerClass: "align-center",
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => {
                if (params.node.rowPinned || !params.value) return '';
                return formatDate(params.value);
            }
        },
    ];

    const fetchData = async (payload) => 
    {
        setLoading(true);
        try 
        {
            const response = await myApi.post('/omni/getCargasOmni', payload);

            if (response?.data?.success) 
            {
                const rows = response.data.data;
                setData(rows);
                setPinnedRow(calculateTotals(rows));
            } 
            else 
            {
                setData([]);
                setPinnedRow([]);
            }
        } 
        catch(error) 
        {
            console.error('Error fetching omni:', error);
            setData([]);
        } 
        finally 
        {
            setLoading(false);
        }
    };

    const handleRegreso = () => 
    {

        let parametros = { startDate: startDate ? startDate.toISOString() : null, endDate: endDate ? endDate.toISOString() : null, unit, driver }

        let info = JSON.stringify(parametros);

        navigate('/diesel/omni/ver', { state: { info: info } });

    }

    const [pinnedRow, setPinnedRow] = useState([]);

    const calculateTotals = (rows) => 
    {
        if (!rows || rows.length === 0) return [];

        const totals = {};

        totals.VehicleID = "TOTAL";

        rows.forEach(row => {
            Object.keys(row).forEach(key => {
                const value = row[key];

                if (typeof value === "number") 
                {
                    totals[key] = (totals[key] || 0) + value;
                }
            });
        });

        return [totals];
    };

    const defaultColDef = {
        cellStyle: params => {
            if (params.node.rowPinned) {
                return {
                    fontWeight: "bold",
                    backgroundColor: "#f5f7fa"
                };
            }
        }
    };

    return (
        <>
        <Paper
            sx={{
                p: 2,
                height: "100%",          // <-- clave
                width: "100%",            // <-- clave
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",       // ok, pero con layout correcto ya no “corta” paginación
                minHeight: 0,            // ✅ nuevo
                boxSizing: "border-box", // ✅ nuevo
            }}
        >
            <Box sx={{ flexShrink: 0 }}>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Grid container>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <Typography variant="h4" fontWeight={700}>
                                <Box component="span" color="primary.main">
                                    Omnitracs
                                </Box>
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <Button
                                type="button"
                                color="inherit"
                                onClick={() => handleRegreso()}
                                variant="contained"
                                startIcon={<ChevronLeftIcon />}
                                sx={{ color: "primary", fontWeight: "bold", width: "190px" }}
                            >
                                Regresar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
            {/* {LISTA DE OMNITRACS} */}   
            <Box sx={{ width: "100%", mt: 1 }}>
                { loading ? (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "calc(100vh - 240px)" }}>
                        <img
                            alt="Cargando..."
                            width="200px"
                            height="200px"
                            src={img} 
                            style={{ cursor: "pointer", borderRadius: "50%" }}
                        />
                    </Box>
                ) : (
                    <div 
                        className="ag-theme-quartz" 
                        style={{ 
                            height: "calc(100vh - 240px)", 
                            minHeight: "400px", 
                            width: "100%" 
                        }}
                    >
                        <AgGridReact
                            rowData={data}
                            columnDefs={columns}
                            pagination={true}
                            autoSizeStrategy={{
                                type: 'fitCellContents'
                            }}
                            enableCellTextSelection={true}
                            pinnedBottomRowData={pinnedRow}
                            defaultColDef={defaultColDef}
                        />
                    </div>
                ) }
            </Box>
        </Paper>
        </>
    )
}

export default Cargas_Omni